import Search from "./inputIcon";

export default Search;
